import React from "react";
import Buttons from "../ui/button/Buttons";
import PropTypes from "prop-types";

const ToolbarButtons = ({
  onActionClick,
  toolbarConfiguration,
  isDisable,
  iconClass,
  ...toolbarProps
}) => {
  return (
    <div className="save-copy-delete-section">
      {toolbarConfiguration.map((item) => (
        <Buttons
          key={item.id}
          isDisable={isDisable}
          titleText={item.titleText}
          isLoading={toolbarProps.isLoading}
          buttonTypeClassName={item.buttonTypeClassName}
          onClick={() => onActionClick(item.actionName)}
          isIcon={item.isIcon}
          iconClass={item.iconClass}
        />
      ))}
    </div>
  );
};

ToolbarButtons.propTypes = {
  onActionClick: PropTypes.func.isRequired,
  toolbarConfiguration: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      titleText: PropTypes.string.isRequired,
      actionName: PropTypes.string.isRequired,
      buttonTypeClassName: PropTypes.string,
      isIcon: PropTypes.bool,
      iconClass: PropTypes.string,
    })
  ).isRequired,
  isDisable: PropTypes.bool,
  iconClass: PropTypes.string,
  toolbarProps: PropTypes.shape({
    isLoading: PropTypes.bool,
  }),
};

export default ToolbarButtons;
